import { apiErrorMessage } from '../../../shared/policies/api-error-message';
import { InvalidRateLineInput } from './build-rate-line-input';

/** The form's own refusal, or the server's reason (an overlap, a deactivated card), shown inline next to what needs fixing. */
export function failureMessageFor(err: unknown): string {
  if (err instanceof InvalidRateLineInput) return err.message;
  return apiErrorMessage(err) ?? 'Could not save the proposal — check the fields and try again.';
}
